<template>
  <div>
    <el-collapse>
      <el-collapse-item :title="$t('normal.base')" name="1">
        <el-row>
          <el-col :span="8">{{$t('normal.name')}}：{{baseInfo.name}}</el-col>
          <el-col :span="8">{{$t('resume.post')}}：{{checkOption(baseInfo.post, status.post)}}</el-col>
          <el-col :span="8">{{$t('normal.time')}}：{{baseInfo.commitDate}}</el-col>
          <el-col :span="8">{{$t('normal.identity_id')}}：{{baseInfo.identity}}</el-col>
          <el-col :span="8">{{$t('normal.gender')}}：{{checkOption(baseInfo.gender, status.gender)}}</el-col>
          <el-col :span="8">{{$t('normal.birthday')}}：{{baseInfo.birthday}}</el-col>
          <el-col :span="8">{{$t('resume.isReproduction')}}：{{checkBoolen(baseInfo.isReproduction)}}</el-col>
          <el-col :span="8">{{$t('resume.isMarried')}}：{{checkBoolen(baseInfo.isMarried)}}</el-col>
          <el-col :span="8">{{$t('resume.politicsState')}}：{{baseInfo.politicsState}}</el-col>
          <el-col :span="8">{{$t('resume.speciality')}}：{{listArray(baseInfo.speciality)}}</el-col>
          <el-col :span="8">{{$t('resume.computerLevel')}}：{{baseInfo.computerLevel}}</el-col>
          <el-col :span="8">{{$t('resume.englishLevel')}}：{{baseInfo.englishLevel}}</el-col>
          <el-col :span="8">{{$t('resume.tips')}}：{{listArray(baseInfo.tips)}}</el-col>
        </el-row>
        <el-row>{{$t('resume.qualifications')}}：</el-row>
        <el-row>
          <el-table :data="baseInfo.qualifications" style="width: 100%">
            <el-table-column prop="date" :label="$t('normal.time')"></el-table-column>
            <el-table-column prop="schoolName" :label="$t('normal.school')"></el-table-column>
            <el-table-column prop="major" :label="$t('resume.major')"></el-table-column>
          </el-table>
        </el-row>
      </el-collapse-item>
      <el-collapse-item :title="$t('resume.contack')" name="2">
        <el-row>
          <el-col :span="6">{{$t('normal.tel')}}：{{baseInfo.tel}}</el-col>
          <el-col :span="6">qq：{{baseInfo.qq}}</el-col>
          <el-col :span="6">{{$t('normal.wechat')}}：{{baseInfo.wechat}}</el-col>
          <el-col :span="6">{{$t('normal.email')}}：{{baseInfo.email}}</el-col>
          <el-col :span="6" v-if="baseInfo.emergencyContact">{{$t('resume.emergencyContact.name')}}：{{baseInfo.emergencyContact.name}}</el-col>
          <el-col :span="6" v-if="baseInfo.emergencyContact">{{$t('resume.emergencyContact.tel')}}：{{baseInfo.emergencyContact.tel}}</el-col>
          <el-col :span="12">{{$t('normal.address')}}：{{baseInfo.address}}</el-col>
        </el-row>
        <el-row>{{$t('resume.families')}}</el-row>
        <el-row>
          <el-table :data="baseInfo.families" style="width: 100%">
            <el-table-column prop="name" :label="$t('normal.name')"></el-table-column>
            <el-table-column prop="relationship" :label="$t('resume.relationship')"></el-table-column>
          </el-table>
        </el-row>
      </el-collapse-item>
      <el-collapse-item :title="$t('resume.resume')" name="3">
        <el-row>{{$t('resume.studyExperience')}}：</el-row>
        <el-row>
          <el-table :data="baseInfo.studyExperience" style="width: 100%">
            <el-table-column prop="beginDate" :label="$t('resume.beginDate')"></el-table-column>
            <el-table-column prop="endDate" :label="$t('resume.endDate')"></el-table-column>
            <el-table-column prop="name" :label="$t('normal.school')"></el-table-column>
            <el-table-column prop="post" :label="$t('resume.post')"></el-table-column>
          </el-table>
        </el-row>
        <el-row>{{$t('resume.careerExperience')}}：</el-row>
        <el-row>
          <el-table :data="baseInfo.careerExperience" style="width: 100%">
            <el-table-column prop="beginDate" :label="$t('resume.beginDate')"></el-table-column>
            <el-table-column prop="endDate" :label="$t('resume.endDate')"></el-table-column>
            <el-table-column prop="name" :label="$t('normal.company')"></el-table-column>
            <el-table-column prop="post" :label="$t('resume.post')"></el-table-column>
          </el-table>
        </el-row>
      </el-collapse-item>
      <el-collapse-item :title="$t('resume.information')" name="4">
        <el-row>
          <el-col :span="8"><img :src="imgUrl + '/' + baseInfo.headimgurl" width="100%"/></el-col>
          <el-col :span="8" :key="index" v-for="(item, index) in baseInfo.picture"><img :src="imgUrl + '/' + item" width="100%"/></el-col>
        </el-row>
      </el-collapse-item>
      <el-collapse-item :title="$t('resume.self')" name="5">
        <el-row>
          <el-col :span="24">{{$t('resume.careerPlanning')}}：{{baseInfo.careerPlanning}}</el-col>
          <el-col :span="24">{{$t('resume.classSpecial')}}：{{baseInfo.classSpecial}}</el-col>
          <el-col :span="8">{{$t('resume.wages')}}：{{baseInfo.wages}}</el-col>
          <el-col :span="8">{{$t('resume.workDate')}}：{{baseInfo.workDate}}</el-col>
        </el-row>
      </el-collapse-item>
      <el-collapse-item :title="$t('resume.adjust')" name="6" v-if="baseInfo.rate">
        <el-row :key="index" v-for="(item,index) in baseInfo.rate">
          <el-col :span="24">{{item.rateName}}：{{item.content}}</el-col>
          <el-col :span="12">{{$t('resume.rate')}}：{{item.score}}</el-col>
          <el-col :span="12">{{$t('normal.time')}}：{{item.createdAt}}</el-col>
        </el-row>
      </el-collapse-item>
      <el-collapse-item :title="$t('resume.character')" name="7" v-if="baseInfo.test">
        <el-row>
          <el-col :span="24" v-if="baseInfo.test.test1">
            <el-row>九重人格测试</el-row>
            <span :key="index" v-for="(item,index) in character.test1">
              <el-popover
                v-if="item.score > 0"
                placement="top-start"
                :title="item.title"
                trigger="hover">
                <div v-html="item.content"></div>
                <el-button slot="reference">{{item.title}}：{{item.score}}</el-button>
              </el-popover>
            </span>
          </el-col>
          <el-col :span="24" v-if="baseInfo.test.test1">
            <el-row>性格彩色测试</el-row>
            <span :key="index" v-for="(item,index) in character.test2">
              <el-popover
                v-if="item.score > 0"
                placement="top-start"
                :title="item.title"
                trigger="hover">
                <div>【性格优势】</div>
                <div :key="'b'+index" v-for="(c,index) in item.benefit" v-html="c"></div>
                <br>
                <div>【性格过当】</div>
                <div :key="'h'+index" v-for="(c,index) in item.harm" v-html="c"></div>
                <el-button slot="reference">{{item.title}}：{{item.score}}</el-button>
              </el-popover>
            </span>
          </el-col>
        </el-row>
      </el-collapse-item>
      <el-collapse-item :title="$t('normal.operate')" name="8" v-if="[7].includes(userInfo.identity)">
        <el-row>
          <div v-if="userInfo.identity === 7">
            <span>打分</span>
            <el-rate
              v-model="operate.score"
              show-text
              :colors="['#99A9BF', '#F7BA2A', '#FF9900']">
            </el-rate>
            <el-row class="line-one"></el-row>
            <el-input
              type="textarea"
              :autosize="{ minRows: 5}"
              placeholder="请输入评价内容"
              v-model="operate.content">
            </el-input>
            <el-row class="line-one"></el-row>
            <el-button type="success" @click="submitScore">提交</el-button>
          </div>
        </el-row>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { mixin, propValue } from '@/mixins/index'
import zhStatus from '@/lang/zh_status'
import enStatus from '@/lang/en_status'
export default {
  mixins: [mixin(), propValue()],
  computed: {
    ...mapState([
      'userInfo',
      'lang'
    ])
  },
  data () {
    const o = this.$route.path.split('/')
    return {
      controller: (o[1] ? o[1] : undefined),
      method: (o[2] ? o[2] : undefined),
      formItem: {
        tel: ''
      },
      formItems: [],
      rules: {},
      dialogImageUrl: '',
      dialogVisible: false,
      loading: false,
      baseInfo: {},
      status: zhStatus,
      operate: {
        id: '',
        score: 3,
        content: ''
      },
      character: {
        test1: [{
          title: '1号型人格——完美主义者',
          score: 0,
          content: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;九型人格中的1号型人格,是追求完美的完美主义者。他们的性格特征就像白色一样明显,人生的座右铭是:“世界是不完美的,我要追求完美。”在生活上,他们多半有洁癖,可能喜欢穿白色的衣服;他们喜欢有秩序的状态,讨厌凌乱和脏的房间,总是把各种东西划分成不同的区域放置,永远知道要找的东西放在哪里;他们不能容忍任何污点,正义感和责任感都很强。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在精神上,他们渴望不断地提高自我,实现完美人生;他们总是希望得到别人的肯定,记得因为做错事而被批评的痛苦,因此学会了严格监督自己,知道要行为得当,要承担责任;他们通常不会注意到是他们自己否定了自己的快乐,脸上表情总是很凝重,表现得永远稳重优雅;他们是制度的拥护者,也是一个不折不扣的工作狂,身为管理者容易对下属求全责备。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在情感上,他们通常显得很冷静,不会把自己的情感外露;他们可能有精神洁癖,对爱情相当忠诚,与此同时他们对伴侣的要求也会很高,眼睛里容不下一颗沙子;他们选择朋友和择偶一样严谨,对友谊忠诚,期盼对方也能给予相同的重视;他们对自己的子女也有很高的要求,希望自己的孩子很出色,一切都要做好做对。无疑,追求完美的性格有利于人不断完善自我,迈向成功,正如亚里士多德说过的那样:“所有天才都有追求完美型的特点。”但完美主义者也会因为过分要求,自信过高认为什么事离开自己结果肯定是一团糟,于是事事亲力亲为,在不知不觉中陷入了自设的牢狱。'
        }, {
          title: '2号型人格——给予者',
          score: 0,
          content: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;九型人格中的2号型人格,是热心的给予者。他们的性格特点就像是温和的绿色,不刺激、有希望的力量,还有温暖人心的热忱。他们就像一幅如同春天般醉人的画面,永远温和暖人的笑容,就像人间四月天里的骄阳和翠柳。在生活上,他们可能是保守而传统的人士,孝敬父母,关心子女,对爱人无微不至;他们是贴心的人生伴侣,无论怎样风雨兼程,都是能够陪伴你走完人生的忠实伴侣。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在精神上,他们永远不会用咄咄逼人的态势来对待别人,温柔体巾而有责任感;他们的表情总是温和而友好,像是随时准备帮助别人;他们乐于助人,很多时候是出于一种“责任”,觉得自己有义务去帮助别人。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在工作上,他们是讨人喜欢的专家,对同事真诚关心,体贴之情常令人感动,同事也因此愿意将内心的真实想法对其倾诉;他们的人缘总是很好,看似吃亏的事情,最后总能获得最大的回报。由于他们这种几乎于无私的“乐于助人”精神,给予者成为九种人格中最受人爱戴的一群人,也是人们最心甘情愿出手提携的对象。每当他们遇到困难的时候,身边总是有愿意鼎力相助的人出现,这就是他们的付出所换来的。然而,给予者为了承担这份他们看来应承担的社会责任,难免会忽略自己的真实意愿,总是尽力让别人高兴。他们不为难任何人,除了自己。长此以往,他们的性格中形成了隐忍、宽厚的一面,同时也会有依赖性太强的特点,他们太习惯按照别人的意思办事。对于他们而言,勇敢扔掉自己依赖的拐杖、掌握自己前进的方向、过自立自强的人生是非常困难的,但也是必须要尝试改变的。英国历史学家弗劳德说:“一棵树如果要结出果实,必须先在土壤里扎下根。同样,一个人首先需要学会依靠自己、尊重自己,不接受他人的施舍,不等待命运的馈赠。只有在这样的基础上,才可能做出成就。”因此,只有身为“独立”个体的给予者,才能称得上是真正意义上的“完整”。'
        }, {
          title: '3号型人格——实用主义者',
          score: 0,
          content: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;九型人格中的3号型人格,是追名逐利的实用主义者。他们的性格特征就像功利的“黑色”,不甘平庸,做事情爱计划,目的性强。“天下攘攘皆为利往,天下熙熙皆为利来”是对其人生最精辟的概括。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在精神上,他们有着难能可贵的务实精神,从来不会将精力浪费在无用的地方;他们和其他人一样都做过百万富翁或其他的伟大梦想,却是少数能为梦想而一直充满斗志的人;他们对名利的热衷是九种人格中最为明显的一群人,在做一件事情的时候总是不断分析它有什么利益可图。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在工作中,他们从很小的时候就为自己确立远大的目标,为达目的可以“不择手段”;他们和1号型的完美主义者一样是典型的工作狂,但性格中的务实精神让他们不会陷入盲目当中,工作效率总是很高;他们考虑问题永远以结果为导向,如果可行性较大,他们就会为此制定一系列具体计划,而不会随波逐流,见到什么热门就跟去凑热闹。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在生活上,他们可能是很有“表演”人格的一群人,会用不同的表情面对不同的人,达到不同的目的,有时候难免让人觉得虚伪和做作;他们习惯于将感情藏在心底,经常会被伴侣埋怨;他们永远将事业放在第一位,所以忽略伴侣的事情有常有发生。无与伦比的创新与独一无二的执行力让实用主义者成为高效率的代表,也较其他人格更易走向成功。他们的成功还源自对目标的准备设定。人世间所有的事情永远只有想不到,没有他们做不到的。只要是能想到的,实用主义就一定能做到。但是实用主义者个性个也存在着较为明显的不足,最突出的就是功利心太强。这种功利心让他们容易患得患失,失去了一颗享受的平常心。实用主义者若能用一颗平常心来对待生活中的一切变迁和选择,试着放慢脚步享受通往成工的过程,或许能获得一种意料之外的财富。'
        }, {
          title: '4号型人格——浪漫主义者',
          score: 0,
          content: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;九型人格中的4号型人格,是想象力丰富的浪漫主义者。他们的性格颜色是紫色,浪漫、高贵、忧伤且极具美感。他们无法忍受庸俗不堪的现实生活,所以会给自己建造一个世外桃源,以释放自己的情感,安放自己的灵魂。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在精神上,他们总有一股忧郁的气质,让人难以捉摸又欲罢不能;他们卓尔不群的审美情趣,让其他几种人格的人望尘莫及;他们是天生的艺术家,表情最多变,高兴的时候他们尽情地开怀大笑,伤心的时候也是号啕大哭,从不惧怕别人的眼光。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在生活上,他们可能是长不大的孩童,因为不喜欢现实生活中的种种虚假,常生活在自己幻想的世界中;他们生活得最自我也最真实,少见虚伪和做作;他们感情细腻,内心活动异常丰富,总是能够像雷达一样迅速传递信息,敏锐地感知到他人的情感;他们会为了让伴侣开心而把自上仅有的钱拿来买花,在他们看来唯有爱才是最宝贵的财富。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在工作上,他们极为丰富的想象力,非常适合需要创作的领域;他们害怕束缚,害怕循规蹈矩,对自由的渴望十分强烈;他们总是做自己感兴趣的工作,不会勉强做自己不喜欢的事情。浪漫主义者是九种人格中最有人格魅力的一群人,他们的身上很少有势利庸俗的因素存在,都宛若不食人间烟火一般,遗世独立,总是能吸引无数人的目光,成为众人心中爱慕的对象。如果他们是男士,就像是上帝送给世间女子的礼物,他们一定浪漫且有品味,一生中肯定会有<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数不尽的女人为其欢笑流泪;如果他们是女士,会美丽简单如空谷幽兰,很容易令男人动情,也一定会成为很多男人心中永远光洁的白玫瑰。就浪漫主义者自身而言,很多时候他们都是活在自己的内心世界里。由于思想难以让人理解,他们大多敏感多情,很容易表现出忧郁的一面,极易得抑郁症,也易产生悲观厌世的情绪。浪漫主义者是生活在云端的一族,他们的言行总是离现实生活越来越远。因此他们需要学会愿意“脚踏实地”地生活,懂得平平淡淡才是真的朴素道理,因为这些简单的东西才是生活的“本色”。'
        }, {
          title: '5号型人格——观察者',
          score: 0,
          content: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;九型人格中的5号人格,是冷静客观的观察者。他们的性格颜色是无所不包、低调而不张扬的灰色。他们就像一位冷眼旁观的裁判,用自己的世界观来替整个世界诊断。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在生活中，他们有着孤独的、寂寞的、思想深刻的灵魂;他们性格沉稳,对不确定的事物总是抱有审慎的态度,希望自己投点代表着客观和公正,因此不轻易发表自己的言论;他们不喜欢与人交往,宁愿独自孤独地面对整个世界;他们总是一副不愿意与别人“深交”的样子,和任何人交往都是“君子之交淡如水”。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在工作中,他们是异常冷静的一群人,理性让他们很少感情用事;他们认为距离是一种安全和尊重,他们没有兴趣走进你的内心,也会永远保留一片属于自己的小天地;他们的脸上永远是一副深沉的思考表情,花在研究理论与事情身上的时间,要远远超过研究人的行为与心理。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;善于观察、勤于思考,喜欢总结是观察者们最好的写照。他们几乎人人都是观察家,凭借敏锐的神经总是能够准确地捕捉到有用的信息，卡，到别人看不到的地方。缜密地思考,然后客观地下结论,这是他们的优势也是别的性格的人所无法与之比拟的地方,而且他们的成功多半与这种喜欢观察和思考的个性有关。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;思考是他们的世界,也是他们生命的全部,仅凭这一点,便足以令其他人汗颜。然而,观察者的理性,有时又严谨得像一台机器,仿佛是与感性“绝缘”的,生活自然少了许多趣味。要学会尝试用一颗感性的心去领悟生活的真谛,会发现这个世界除了淡定得有点冰冷的灰色外,还有很多其他温暖的颜色,可以令心中的世界也变得明媚许多。'
        }, {
          title: '6号型人格——怀疑论者',
          score: 0,
          content: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;九型人格中的6号人格,是谨慎敏感的怀疑论者。他们的性格颜色与蓝色很相似:柔和冷静的表面之下往往还有阴郁的一面。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在工作上,他们怀疑权威者的一切论点,企图找到可以攻击的地方;他们在接受一项任务的时候,首先想到的不是成功,而是万一失败了怎么办;他们总能想到最坏的一面,也总是怀疑别人对他们心怀不轨;他们有超强的责任心,是一群值得信赖的人;过分谨慎的性格常让他们裹足不前,容易丧失机会;他们害怕失败,不敢轻易决定,他们希望能够得到强有力的保护和指引。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在生活上,他们总爱把自己假定为“受害者”,好像全天下的人都对不起他,也都要对他不利,因而多半生性敏感多疑;他们总是不确定事情的真假和好坏,因此脸上总是带着研究的表情;他们难以相信任何人,甚至有时连自己都不信任,因此生活得战战兢兢、如履薄冰。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;他们大多心细如发,过度敏感,习惯于对别人的一言一行、一举一动都加上自己想象出来的消极的“旁白”;他们都有一种自贬自责的倾向,一点小小的挫折都会记在心里,随即开始怀疑自己的各个方面。于是所有外界的批评都是有道理的、应该的,一切都是自己的错,换句话说:我自己一无是处,太平庸了,是个傻瓜……在这一点上,怀疑论者无疑是有点过度敏感了。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;怀疑论者因这种过度敏感心理的存在,终日生活在“防御”状态之下,十分痛苦。英国思想家培根说:“猜疑之心有如蝙蝠,它总是在黄昏中起飞。这种心情是迷陷人的,又是乱人心智的。它将最终导致一个人做错事情。”过度敏感心理发展到后来,极有可能变成重度猜疑,甚至是更为严重的心理疾病。这样,不仅他们自己的生活过得很辛苦,周围的人跟着他们也不会有好日子过。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;或许,怀疑论者应该学着多一点信任,多一点放心,少一点防守,少一点固执。毕竟,这个世界上,真正与人为敌的只是少数,绝大多数人还是希望与人相处得愉快,过平淡充实的日子的。'
        }, {
          title: '7号型人格——享受主义者',
          score: 0,
          content: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;九型人格中的7号型人格,是及时行乐的享受主义者。他们的性格颜色是快乐的橙色,他们的生活哲学是:人生不如意之事十之八九,何不开心快乐点?<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在生活上,他们豁达乐观,脸上永远洋溢着快乐,烦恼对他们而言,只不过是浮云;他们认为生命太短暂,要抓紧时间享受,因此崇奉今朝有酒今朝醉的生活哲学;他们轻松愉快,是个开心果,绝对是一个让朋友放松的人;他们追求无拘无束的生活,不愿意带给别人压力,也害怕别人给他们施压;他们自信风趣、懂得享受生活,喜欢去冒险尝试所有的美好,是个典型的“万人迷”,但拒绝承诺,惧怕责任。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在工作上,他们赚钱是次要的,懂得如何享受生活才是最重要的,因而不会给同事或下属带来压力;他们很少有“世俗”的偏见,不会因为你曾经的失足而嘲笑你,也不会因为你的成就而嫉妒你;他们可能是个多才多艺的同事,天生能够给别人快乐,能和任何人都打成一片。享受主义者是典型的乐观主义者,对他们而言,不论生活遭遇到了什么,它们对于生活的热情都不会减退或消失。享受主义者的生活因为洋溢的热情而多姿多彩,使他们成为最有情调,也是就懂得享受生活的一群人。但他们对于一件事情的热情,往往来得快,去得也快。由于享受主义者属于典型的害怕吃苦的人,于是,做事虎头蛇尾、三天打鱼两天晒网,成了他们的常态。毕竟,放弃一件事情总比坚持一件事容易得多,因而这世界多的是失意的放弃的人,少有坚持到底的人。若享受主义者能在拥有饱满热情的同时,练就一颗勇往直前、坚持不懈的心,他们的人生必定会圆满许多。'
        }, {
          title: '8号型人格——保护者',
          score: 0,
          content: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;九型人格中的8号型人格,是号令天下的领导者,也是锄强扶弱的保护者。他们的性格颜色是象征着权力、热情、欲望、尊贵夺目的红色。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;他们的表情是严肃的,像一头雄狮一样充满威严,尊贵而勇敢;他们是最有勇气的人,可能为了帮助弱小者挺身而出,也可能为了反对某种不合理的制度带头“革命”;他们的正义感很强,习惯并且也热衷于提携他人、保护他人,尤其是弱小的人;他们对强权从来不会屈服,只要是认定了的事情,就一定能够坚持到底;他们像是一颗参天大树,带给很多人独一无二的安全感;他们会将伴侣为应该受到保护的对象,在他们看来,爱他(她)就是要保护他(她)不受伤害;他们不习惯表露感情,有时候甚至用激怒对方的方式来确认对方对自己的感情;他们习惯于扮演领导者,喜欢居高临下地发号施令,强势的个性可能会让人吃不消。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;拥有强势独立个性的领导者,从来不会为了将就而“随大流”,相反,在他们看来,那些弱者或落后者,才是他们应该给予支持和帮助的。丘吉尔说:“通气很有理由被当作人类德性之首,因为这种德性保证了所有其余的德性。”领导者所拥有的,便是其他类型的人所不具有的“勇气”,一种愿意为了崇高的理想而奉献自己鲜血,甚至是生命的勇气。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;生活中,人与人之间难免产生误会、摩擦,如果对一些无伤大雅的小事也处处深究的话,不满、抱怨,甚至是仇恨会在心底悄悄滋长。时间久了,自认为是正义执行者的领导者有可能想要通过“报复”的方式加以还击。其实,最高明的打击“敌人”的办法,不是“报复”,而是将其变成朋友。美国政治家林肯曾说:“我们难道不是在消灭政敌吗?当我们成为朋友时,政敌就不存在了。”如此一来,不仅问题解决了,领导者的心也不必再受仇恨的折磨,可以重获自由了。'
        }, {
          title: '9号型人格——协调者',
          score: 0,
          content: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;九型人格中的9号型人格,是纵横捭(bai)阖(he)的协调者。他们的性格颜色是明媚的黄色,能力不一定是最强的,但影响力一定是最大的。他们胸怀博大,位居榜首,是其他型的人格无法比拟的;他们尽力避免争吵,通常不会和别人发生毫无意义的争论,也很少因为不同政见而和别人争吵;他们以极其优越的协调性将争执的各方都聚集到一起,用求同存异的方式将大家聚扰在自己周围;他们不会是某个领域的专家,从事的最常见的工作可能是上传下达的秘书;他们不会要求别人一定要赞同自己的观点,相反让为每个人的建议都有独到之处;他们清楚周围人的强项与短处,在面临重大问题的时候总是能够找到“能用”的人,非常善于利于“关系”来办事;他们脾气温和,会是不错的人生伴侣;他们可能是被动的人,不愿意主动去解决问题;他们永远温文尔雅,像英国绅士一样礼貌周到,但却喜欢抱怨,而且骨子里却相当固执,甚至爱钻牛角尖。合纵连横,纵横捭阖,是协调者的强势。只要他们一出马,合作中可能出现的消极效应,都会因协调者极强的协调能力而烟消云散。然而,协调者也并非完美无缺的。虽然他们从来不缺少好主意,但面对那么多看来各具独到之处的建议,他们一方面觉得都有道理,另一方面又谁也不想得罪,于是自己便陷入了无所适从的艰难抉择之中。例如三国时期的袁绍,他手下文臣武将众多,每次遇难到大事他的谋士们都会尽职尽责地替他出谋划策。但是他常常因为不能决策而错过最佳时机,最后往往以失败告终。袁绍兵败,曹操占领了他的地盘后曾说:“燕赵多义士,本初(袁绍的字)若能善加利用何至于输给老夫?”确实,在可遇不可求的机会面前,作为一个组织的协调者和领导者,果断地作出决策是其能力的重要体现,而这点正是协调者不断需要加强的。'
        }],
        test2: [{
          title: '红色',
          score: 0,
          benefit: [
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为个体：高度乐观的积极心态。喜欢自己，也容易接纳别人。把生命当作值得享受的经验。喜欢新鲜、变化和刺激。经常开心，追求快乐。情感丰富而外露。自由自在，不受拘束。喜欢开玩笑和调侃。别出心裁，与众不同。表现力强。容易受到人们的喜欢和欢迎。生动活泼，好奇心强。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;沟通特点：才思敏捷，善于表达。喜欢通过肢体上的接触传达亲密情感。容易与人攀谈。发生冲突时，能直接表白。人越多越亢奋。演讲和舞台表演的高手。乐于表达自己的看法。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为朋友：真诚主动，热情洋溢。喜欢交友，善于与陌生人互动。擅长搞笑，是带来乐趣的伙伴。容易原谅自己和别人，不记仇。富有个人魅力。乐于助人。有错就认，很快道歉。喜欢接受别人的肯定和不吝赞美。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对待工作和事业：工作主动，寻找新任务。富有感染力，能够吸引他人参与。激发团队的热情合作心和进取心，重视团队合作的感觉。令人愉悦的工作伙伴。完成短期目标时，极富爆发力。信任他人。善于赞美和鼓励，是天生的激励者。不喜欢太多的规定束缚，富有创意。工作以活泼化、丰富化的方式进行。反应快，闪电般开始。'
          ],
          harm: [
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为个体：情绪波动大起大落。变化无常，随意性强。鲁莽冲动，轻信他人，容易上当受骗。虚荣心强，不肯吃苦，贪图享受。喜欢走捷径，虎头蛇尾，不能坚持。粗心大意，杂乱无章。不肯承担责任，期待有别人为自己的人生负责。缺乏自控，毫无纪律。容易原谅自己，不吸取教训。不稳定和散漫。拒绝长大。借放纵来麻痹自己的痛苦和烦恼，而不去认真思考生命的本质。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;沟通特点：说话少经大脑思考，脱口而出。对于严肃和敏感的事情也会开玩笑。炫耀自己，夺人话题。注意力分散，不能专注倾听，插话。吹牛不打草稿，疏于兑现承诺。忘记别人说过什么，自己讲过的话也经常重复。口无遮拦，不保守秘密。不可靠，光说不练。夸大吹嘘自己的成功。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为朋友：缺少分寸，过度的玩笑和热情。只想当主角。谈论自己感兴趣的话题，对和自己无关的话题心不在焉。插嘴打断别人谈话。健忘多变。经经常会忘记老朋友。有极强的依赖性，脆弱而不能独立。好心办坏事。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对待工作事业：跳槽频率高，这山望着那山高。没有规划，随意性强。没有焦点，把精力分散在太多的不同方向。过高估计了自己的能力。觉得没有必要为未来做准备。不肯花更大的精力和幕后工作的勤奋代价，来获取更高的殊荣。不切实际地希望所有的工作都要有趣味。很难全神贯注，经常性地走神。异想天开，难以预料。'
          ]
        }, {
          title: '蓝色',
          score: 0,
          benefit: [
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为个体：严肃的生活哲学。思想深邃，独立思考而不盲目从众。沉默寡言，老成持重。注重承诺，可靠安全。谨慎而深藏不露。坚守原则，责任心强。遵守规则，井井有条。深沉有目标的理想主义。敏感细腻。高标准，追求完美。谦和稳健。善于分析，富有条理。待人忠诚，富有自我牺牲精神。深思熟虑，三思而后行。坚韧执着。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;沟通特点：享受敏感而有深度的交流。设身处地地体会他人。能记住谈话时共鸣的感情和思想。喜欢小群体交流的思想碰撞。关注谈话的细节。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为朋友：默默地为他人付出以表示关切和爱。对友谊忠诚不渝。真诚关怀朋友的境遇，善于体贴他人。能够记得特殊的日子。遭遇难关时，极力给予鼓舞安慰。很少向他人表达内心的看法。经常扮演解决分析问题的角色。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对待工作和事业：强调制度、程序、规范、细节和流程。做事之前首先计划且严格按照计划去执行。喜欢探究及根据事实行事。尽忠职守，追求卓越。高度自律。喜欢用表格、数字的管理来验证效果。注重承诺。一丝不苟地执行工作。'
          ],
          harm: [
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为个体：高度负面的情绪化。猜忌心重，不信任他人。太在意别人的看法和评价，容易被负面评价中伤。容易沮丧，悲观消极。陷于低落的情绪无法自拔。情感脆弱抑郁，有自怜倾向。杞人忧天，庸人自扰。最容易的抑郁症患者。当别人轻易成功时，会因自己的努力付出却不如他人而心生嫉妒。过于阴沉的面孔，让人感觉压抑，不易接近。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;沟通特点：不知不觉地说教和上纲上线。原则性强，不易妥协。强烈期待别人具有敏感度和深度能够理解自己。以为别人能够读懂自己的心思。不太主动与人沟通。不喜欢制造困扰麻烦给别人，也讨厌别人制造困扰麻烦给自己。要真诚开放心胸与人互动会比较难。习惯以防卫的状态面对别人。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为朋友：过度敏感，有时很难相处。强烈的不安全感。远离人群。喜好批判和挑剔。吝于宽恕。经常怀疑别人的话，不容易相信他人。对待工作和事业对自己和他人常寄予过高而且不切实际的期望。过度计划和过度绸缪。患得患失，行动缓慢。较真，挑剔他人及自己的表现。专注于小细节，因小失大。吝啬表扬，强烈的形式主义。容易被不理想的成绩击垮斗志。墨守成规，死板教条不懂变通。为了维护原则缺乏妥协精神。'
          ]
        }, {
          title: '黄色',
          score: 0,
          benefit: [
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为个体：不达目标，誓不罢休。不停地给自己设定目标以推动前进。把生命当成竞赛。行动迅速，活力充沛。意志坚强。自信、不情绪化，而且非常有活力。坦率，直截了当，一针见血。强烈的进取心，居安思危。独立性强。有强烈的求胜欲。不畏强权并敢于冒险。不易气馁，不在乎外界的评价，坚持自己所选择的道路和方向。危难时刻挺身而出。讲究速度和效率。敢于接受挑战并渴望成功。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;沟通特点：以务实的方式主导会谈。喜欢主导整个事情进行的方式。能够直接抓住问题的本质。说话用字简明扼要，不喜欢拐弯抹角。不受情绪干扰和控制。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为朋友：给予解决问题的方法，而非纠缠在过去。迅速提出忠告和方向。直言不讳地提出建议。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对待工作和事业：动作干净利落，讲求效率。能够承担长期高强度的压力。强烈的目标趋向，善于设定目标。高瞻远瞩，有全局观念。善于委派工作。坚持不懈，促成活动。掌握重点执行。行事作风明快。天生的领导者和富有组织能力。竞争越强，精力越旺，愈挫愈勇。寻求实际的解决方法。以结果和完成任务为导向，并且高效率。善于快速决策并处理所遇到的一切问题。富有责任感。'
          ],
          harm: [
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为个体：自己永远是对的，死不认错。趾高气扬，霸道。只关注自己的感受，不体贴别人的心情和想法。以自我为中心，自私倾向。霸道。脾气暴躁，容易发怒。缺少同情心。傲慢自大，目中无人。经常紧绷自己的情绪。在情绪不佳或有压力的时候，经经常会不可理喻与独断专行。不喜欢受群体所规范约束，打破既定规则且自己不遵守规则。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;沟通特点：喜欢争辩和冲突。铁石心肠，对情绪表现冷淡。粗线条，简单粗暴。毫无敏感，无力洞察他人内心和理解他人所想。抗拒批评，严酷且自以为是的审判者。缺乏亲密分享的能力。缺乏耐心，是非常糟糕的倾听者。态度尖锐严厉，批判性强。容易让他人的工作或生活步调紧张。不习惯赞美别人。说话有时咄咄逼人。控制欲强。不太能体谅他人，对行事模式不同的人缺少包容度。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为朋友：大多时候仅保持理性的友谊。讨厌与犹豫不决、能力弱的人互动。试图控制和影响大家的活动，希望他人服从自己而非配合别人。除了工作内容，很少交谈其它话题。情感上习惯与人保持一定的距离。很少对人流露出直接诚挚的关怀。需要你的时候才找你。为别人做主。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对待工作和事业：生活在无尽的工作当中而不是人群中。数量远比质量重要。目标没有完成时，容易发怒且迁怒于人。寻求更多的权力，有极强的控制欲。拒绝为自己和他人放松。完成工作第一，人的事情第二。为了自己的面子，不妥协且毫不认错。对于竞争结果过分关注而忽略过程中的乐趣。武断，刚愎自用且一意孤行。很难慢下来，缺少生命乐趣的工作狂。未明察就急于改变，急于求成。'
          ]
        }, {
          title: '绿色',
          score: 0,
          benefit: [
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为个体：爱静不爱动，有温柔祥和的吸引力和宁静愉悦的气质。和善的天性，做人厚道。追求人际关系的和谐。奉行中庸之道，为人稳定低调。遇事以不变应万变，镇定自若。知足常乐，心态轻松。追求平淡的幸福生活。有松弛感，能融入所有的环境和场合。从不发火，温和、谦和、平和三和一体。做人懂得“得饶人处且饶人”。追求简单随意的生活方式。沟通特点以柔克刚，不战而屈人之兵。避免冲突，注重双赢。心平气和且慢条斯理。善于接纳他意见。最佳的倾听者，极具耐心。擅长让别人感觉舒适。有自然和不经意的冷幽默。松弛大度，不急不徐。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为朋友：从无攻击性。富有同情和关心。宽恕他人对自己的伤害。能接纳所有不同性格的人。和善的天性及圆滑的手腕。对友情的要求不严苛。处处为别人考虑，不吝付出。与之相处轻松自然又没有压力。最佳的垃圾宣泄处，鼓励他们的朋友多谈自己。从不尝试去改变他人。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对待工作和事业：高超的协调人际关系的能力。善于从容地面对压力。巧妙地化解冲突。能超脱游离政治斗争之外，没有敌人。缓步前进以取得思考空间。注重人本管理。推崇一种员工都积极参与的工作环境。尊重员工的独立性，从而博得人心和凝聚力。善于为别人着想。以团体为导向。创造稳定性。用自然低调的行事手法处理事务。'
          ],
          harm: [
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为个体：按照惯性来做事，拒绝改变，对于外界变化置若罔闻。懒洋洋的作风，原谅自己的不思进取。懦弱胆小，纵容别人欺压自己。期待事情会自动解决，完全守望被动。得过且过。无原则地妥协，而无法促使他们采取负责任的解决态度。逃避问题与冲突。太在意别人反应，不敢表达自己的立场和原则。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;沟通特点：一拳打在棉花上，毫无反应。没有主见，把压力和负担通通转嫁到他人身上。不会拒绝他人，给自己和他人都带来无穷麻烦。行动迟钝，慢慢腾腾。避免承担责任。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为朋友：不负责任的和稀泥。姑息养奸的态度。压抑自己的感受以迁就别人。期待让人人满意，对自己的内心不忠诚。没有自我，迷失人生的方向。缺乏激情。漠不关心，惰于参与任何活动。',
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对待工作和事业：安于现状，不思进取。乐于平庸，缺乏创意。害怕冒风险，缺乏自信。拖拖拉拉。缺少目标。缺乏自觉性。懒惰而不进取。宁愿做旁观者不肯做参与者。'
          ]
        }]
      }
    }
  },
  methods: {
    submitScore () {
      this.postFetch('/api/resume/submitScore', this.operate, { needSuccess: true }).then(r => {
      })
    },
    toManayFile () {
      this.$message({
        message: this.$t('normal.fileLimit')
      })
    },
    handleSuccess (file, fileList) {
      this.formItem[file.data.name].push(file.data.respData.key)
      this.buffValue()
    },
    handleRemove (file, fileList) {
      this.formItem[file.response.data.name] = []
      for (let fileItem in fileList) {
        this.formItem[file.response.data.name].push(fileList[fileItem].response.data.respData.key)
      }
      this.buffValue()
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    buffValue () {
      const item = this.controller + this.method
      this.$localStorage.set(item, JSON.stringify(this.formItem))
    },
    onSubmit (name) {
    },
    checkOption (value, option) {
      if (option) {
        for (let i = 0; i < option.length; i++) {
          if (option[i].value === value) {
            return option[i].label
          }
        }
      }
    },
    listArray (value) {
      if (typeof value === 'object') {
        let v = ''
        for (let i = 0; i < value.length; i++) {
          v += value[i] + ' '
        }
        return v
      }
      return value
    },
    checkBoolen (value) {
      if (value === 0) {
        return '否'
      } else {
        return '是'
      }
    }
  },
  async created () {
    switch (this.lang) {
      case 'zh':
        this.status = zhStatus
        break
      case 'en':
        this.status = enStatus
        break
    }
    this.status.post = await this.$store.dispatch('getOption', 'resume_post')
    this.getFetch('/api/resume/getone', { id: this.$route.query.id }).then(r => {
      this.baseInfo = r
      this.operate.id = r._id
      if (r.test) {
        if (r.test.test1) {
          const value = [0, 0, 0, 0, 0, 0, 0, 0, 0]
          for (let i = 0; i < r.test.test1.length; i++) {
            if (r.test.test1[i].value) {
              value[r.test.test1[i].score - 1]++
            }
          }
          for (let i = 0; i < value.length; i++) {
            this.character.test1[i].score = value[i]
          }
          this.character.test1.sort((a, b) => { return b.score - a.score })
        }
        if (r.test.test2) {
          const value1 = [0, 0, 0, 0]
          const value2 = [0, 0, 0, 0]
          for (let i = 0; i < r.test.test2.length; i++) {
            if (i < 15) {
              value1[r.test.test2[i].value]++
            } else {
              value2[r.test.test2[i].value]++
            }
          }
          this.character.test2[0].score = value1[0] + value2[3]
          this.character.test2[1].score = value1[1] + value2[2]
          this.character.test2[2].score = value1[2] + value2[1]
          this.character.test2[3].score = value1[3] + value2[0]
          this.character.test2.sort((a, b) => { return b.score - a.score })
        }
      }
    })
  }
}
</script>

<style lang="css">
  .line-one{
    height: 22px;
  }
</style>
